<script>
import moment from "moment";
import axios from '@/utils/axios';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";

export default {
 inject: ['setLoading'],
 data() {
  return {
    title: "CRM",
    text: "CRM",
    search: '',
    status: '', 
    fromDate: '',
    toDate: '',
    filterBy: 'created_at',
    filterByOptions: [
      { value: 'created_at', label: 'Created Date' },
      { value: 'order_date', label: 'Order Date' },
      { value: 'dispatch_date', label: 'Dispatch Date' },
    ],
    dateRangeTimeout: null,
    totalCount: 0,
    statusOptions: [  
     { value: 'pending', label: 'Pending' },
     { value: 'approval_pending', label: 'Approval Pending' },
     { value: 'approved', label: 'Approved' },
     { value: 'ready_for_dispatch', label: 'Ready for Dispatch' },
     { value: 'dispatched', label: 'Dispatched' },
     { value: 'rejected', label: 'Rejected' },
     { value: 'partial_dispatched', label: 'Partial Dispatched' },
   ],
    tableColumns: [
      { key: 'file_number', label: 'File Number' },
      { key: 'order_number', label: 'Order No' },
      { key: 'name', label: 'Name' },
      { key: 'mobile', label: 'Mobile' },
      // { key: 'address', label: 'Address' },
      { key: 'order_date', label: 'Order Date' },
      { key: 'dispatch_date', label: 'Dispatch Date' },
      { key: 'created_at', label: 'Created Date' },
      { key: 'windows_qty', label: 'Windows Qty' },
      { key: 'glass_status', label: 'Glass Status' },
      { key: 'delivery_status', label: 'Delivery Status' },
      { key: 'approval_remark', label: 'Approval Remark' },
      { key: 'actions', label: 'Actions' },
    ],
    data: [],
    pagination: {
     current_page: 1,
     per_page: 50,
     last_page: 1,
     total: 0,
     links: []
    },
    whatsappLogs: [],
    whatsappLogsLoading: false,
    whatsappLogModalTitle: '',
   };
  },

computed: {
  text1(){
   return `Total Customer Dispatch (${this.totalCount})`;
  },
  summaryLabel(){
   return this.status ? this.statusLabel(this.status) : 'Total Customer Dispatch';
  },
  summaryIcon(){
   const iconMap = {
     pending: 'ti-clock',
     approval_pending: 'ti-hourglass',
     approved: 'ti-circle-check',
     ready_for_dispatch: 'ti-package',
     dispatched: 'ti-truck',
     rejected: 'ti-ban',
     partial_dispatched: 'ti-truck-loading',
   };
   return this.status ? (iconMap[this.status] || 'ti-list') : 'ti-list';
  },
},

beforeUnmount(){
   clearTimeout(this.dateRangeTimeout);
  },

  mounted(){
   this.fetchDispatches();
   this.fetchTotalCount();

   const start = moment().subtract(29, "days");
   const end = moment();

   const picker = new DateRangePicker(
     this.$refs.dateRangeInput,
     {
       startDate: start,
       endDate: end,
       autoUpdateInput: false,
       locale: {
         format: "DD/MM/YYYY",
         separator: " - ",
         cancelLabel: "Clear"
       },
       ranges: {
         Today: [moment(), moment()],
         Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
         "Last 7 Days": [moment().subtract(6, "days"), moment()],
         "Last 30 Days": [moment().subtract(29, "days"), moment()],
         "This Month": [moment().startOf("month"), moment().endOf("month")],
         "Last Month": [
           moment().subtract(1, "month").startOf("month"),
           moment().subtract(1, "month").endOf("month"),
         ],
       }
     },
     (start, end) => {
       this.setDateRange(start, end);
       this.$refs.dateRangeInput.value = `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`;
     }
   );

   if (picker && picker.container) {
     picker.container.on('click', '.ranges li', (e) => {
       const label = e.target.getAttribute('data-range-key');
       if (label && picker.ranges[label]) {
         const [s, en] = picker.ranges[label];
         this.setDateRange(s, en);
         this.$refs.dateRangeInput.value = `${s.format("DD/MM/YYYY")} - ${en.format("DD/MM/YYYY")}`;
       }
     });

     picker.container.on('click', '.cancel', () => {
       this.fromDate = '';
       this.toDate = '';
       this.$refs.dateRangeInput.value = '';
       this.fetchDispatches();
     });
   }
  },

  methods: {

        setDateRange(start, end) {
      if (this.dateRangeTimeout) {
        clearTimeout(this.dateRangeTimeout);
      }
      this.fromDate = start.format("YYYY-MM-DD");
      this.toDate = end.format("YYYY-MM-DD");
      this.dateRangeTimeout = setTimeout(() => {
        this.fetchDispatches();
      }, 300);
    },

    async openWhatsappLogs(row) {
  this.whatsappLogModalTitle = row.file_number || '';
  this.whatsappLogs = [];
  this.whatsappLogsLoading = true;
  this.$openModal('whatsapp_logs_modal');
  try {
    const response = await axios.get(`/whatsapp-logs/CustomerDispatch/${row.id}`);
    this.whatsappLogs = response.data.data || [];
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.whatsappLogsLoading = false;
  }
},

whatsappStatusBadge(status) {
  const map = {
    sent: 'bg-success-subtle text-success',
    failed: 'bg-danger-subtle text-danger',
    pending: 'bg-warning-subtle text-warning',
  };
  return map[status] || 'bg-secondary-subtle text-secondary';
},

formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
},

async fetchTotalCount() {
  try {
    const response = await axios.get(`/customer-dispatches?page=1`);
    this.totalCount = response.data.data.total;
  } catch (error) {
    console.log(error.message);
  }
},

async approveDispatch(id) {
  const { value: remark } = await this.$swal({
    title: 'Approve Dispatch',
    input: 'textarea',
    inputLabel: 'Approval Remark (Optional)',
    inputPlaceholder: 'Enter remark...',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Approve',
  });
  if (remark !== undefined) {
    this.setLoading(true);
    try {
      await axios.patch(`/customer-dispatches/${id}/approve`, { approval_remark: remark || '' });
      this.$swalToast('Dispatch approved successfully', 'success');
      this.fetchDispatches();
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},

async rejectDispatch(id) {
  const { value: remark } = await this.$swal({
    title: 'Reject Dispatch',
    input: 'textarea',
    inputLabel: 'Rejection Remark (Optional)',
    inputPlaceholder: 'Enter remark...',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, Reject',
    confirmButtonColor: '#dc3545',
  });
  if (remark !== undefined) {
    this.setLoading(true);
    try {
      await axios.patch(`/customer-dispatches/${id}/reject`, { approval_remark: remark || '' });
      this.$swalToast('Dispatch rejected', 'success');
      this.fetchDispatches();
    } catch (error) {
      this.$swalToast(error.message, 'error');
    } finally {
      this.setLoading(false);
    }
  }
},


    openUpdateStatus(row) {
  this.$refs.dispatchModal.openStatusModal(row);
},

    statusBadgeClass(status) {
  if (status === 'dispatched') return 'badge-orange';
  if (status === 'partial_dispatched') return 'badge bg-purple text-white';
  if (status === 'ready_for_dispatch') return 'badge-yellow';
  if (status === 'pending') return 'badge bg-warning text-dark';
  if (status === 'approval_pending') return 'badge bg-info text-white';
  if (status === 'rejected') return 'badge bg-danger';
  return 'badge bg-secondary';
},

statusLabel(status) {
  if (status === 'dispatched') return 'Dispatched';
  if (status === 'partial_dispatched') return 'Partial Dispatched';
  if (status === 'ready_for_dispatch') return 'Ready for Dispatch';
  if (status === 'pending') return 'Pending';
  if (status === 'approval_pending') return 'Approval Pending';
  if (status === 'approved') return 'Approved';
  if (status === 'rejected') return 'Rejected';
  return status;
},
    
    async fetchDispatches(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       search: this.search.trim() || '' 
      };
      if (this.status) params.delivery_status = this.status;
      if (this.fromDate) params.date_from = this.fromDate;
      if (this.toDate) params.date_to = this.toDate;
      if (this.fromDate || this.toDate) params.filter_by = this.filterBy;
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/customer-dispatches?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    // changePage(url){
    //  if (!url) return;
    //  const page = new URL(url).searchParams.get("page");
    //  this.fetchDispatches(page);
    // },

   clearFilter(){
    this.search = '';
    this.status = ''; 
    this.fromDate = '';
    this.toDate = '';
    this.filterBy = 'created_at';
    if (this.$refs.dateRangeInput) {
      this.$refs.dateRangeInput.value = '';
    }
    this.fetchDispatches();
   },
      async exportCsv(){
    this.setLoading(true);
    try{
     const params = {
      search: this.search.trim() || '',
      export: 'csv',
     };
     if (this.status) params.delivery_status = this.status;
     if (this.fromDate) params.date_from = this.fromDate;
     if (this.toDate) params.date_to = this.toDate;
     if (this.fromDate || this.toDate) params.filter_by = this.filterBy;
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/reports/customer-dispatch?${query_string}`, {
      responseType: 'blob'
     });
     const blob = new Blob([response.data], { type: response.headers['content-type'] });
     const link = document.createElement('a');
     link.href = URL.createObjectURL(blob);
     let filename = 'customer_dispatch_export.csv';
     const disposition = response.headers['content-disposition'];
     if(disposition && disposition.indexOf('filename=') !== -1){
      const filenameMatch = disposition.match(/filename="?(.+)"?/);
      if (filenameMatch.length === 2) filename = filenameMatch[1];
     }
     link.download = filename;
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
     URL.revokeObjectURL(link.href);
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

   formatDate(date) {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
   },

   // ===== Modal openers =====
   async openViewDispatch(id) {
     await this.$refs.dispatchModal.openView(id);
     this.$openModal('customer_dispatch_modal');
   },

   async openEditDispatch(id) {
     await this.$refs.dispatchModal.openEdit(id);
     this.$openModal('customer_dispatch_modal');
   },

   openAddDispatch() {
     this.$refs.dispatchModal.openCreate();
     this.$openModal('customer_dispatch_modal');
   },

   openDeleteDispatch(row) {
     this.$refs.dispatchModal.openDelete(row);
     this.$openModal('customer_dispatch_delete_modal');
   },
    
  },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
  <div class="content">
   <!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
  <breadcrumb :title="title" :text="text" :text1="text1" />
  
  <!-- Summary Count Card - inline with breadcrumb -->
  <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
    <button type="button" class="btn btn-white border d-inline-flex align-items-center" @click="exportCsv()">
      <i class="ti ti-file-export me-1"></i>Export CSV
    </button>

    <div class="card mb-0" style="min-width: 220px;">
      <div class="card-body d-flex align-items-center justify-content-between py-2 px-3">
        <div style="margin-right: 5px;">
          <p class="mb-0 text-muted fs-13">{{ summaryLabel }}</p>
          <h5 class="mb-0">{{ pagination.total }}</h5>
        </div>
        <div>
          <span class="avatar avatar-md bg-primary-transparent">
            <i :class="`ti ${summaryIcon} fs-20`"></i>
          </span>
        </div>
      </div>
    </div>

  </div>

</div>
<!-- /Breadcrumb -->

    <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
    <h5>Customer Dispatch List</h5>
    
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">

          <!-- Filter By Date Type -->
    <div class="me-3">
    <vue-select
      v-model="filterBy"
      :options="filterByOptions"
      label="label"
      :reduce="s => s.value"
      :clearable="false"
      @update:modelValue="fetchDispatches(1)"
      style="min-width: 150px;"
    ></vue-select>
    </div>

    <!-- Date Range Picker -->
    <div class="me-3">
    <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput"
      placeholder="dd/mm/yyyy - dd/mm/yyyy" style="min-width: 210px;" />
    </div>

    <!-- Delivery Status Filter — NEW -->
    <div class="me-3">
    <vue-select
      v-model="status"
      :options="statusOptions"
      label="label"
      :reduce="s => s.value"
      placeholder="All Status"
      :clearable="true"
      @update:modelValue="fetchDispatches(1)"
      style="min-width: 180px;"
    ></vue-select>
    </div>

    <div class="me-3" v-if="search || status || fromDate || toDate">
    <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
    <div class="input-icon-end position-relative">
    <input type="text" class="form-control" v-model="search" placeholder="Search...." @keyup.enter="fetchDispatches()"/>
    </div>
    </div>

    <div class="me-3">
    <button type="button" class="btn btn-dark" @click="fetchDispatches()"><i class="ti ti-search"></i></button>
    </div>

    </div>
    
   </div>

<div class="card-body card-table-wrapper">
  <app-table
    :columns="tableColumns"
    :rows="data"
    :pagination="pagination"
    :loading="false"
    :skeleton-rows="5"
    empty-text="No records found."
    empty-icon="ti ti-truck-off"
    @page-change="fetchDispatches"
  >

    <!-- File Number -->
    <template #file_number="{ row }">
      <a href="javascript:void(0);" @click="openViewDispatch(row.id)" class="fw-bold text-primary">{{ row.file_number }}</a>
    </template>

    <!-- Order Number -->
    <template #order_number="{ row }">
      {{ row.order_number || '-' }}
    </template>

        <!-- Name -->
    <template #name="{ row }">
        {{ row.customer?.name || '-' }}
    </template>

    <!-- Mobile -->
    <template #mobile="{ row }">
        {{ row.customer?.mobile || '-' }}
    </template>

    <!-- Order Date -->
    <template #order_date="{ row }">
      {{ formatDate(row.order_date) }}
    </template>

    <!-- Dispatch Date -->
    <template #dispatch_date="{ row }">
      {{ formatDate(row.dispatch_date) }}
    </template>

    <!-- Created Date -->
    <template #created_at="{ row }">
      {{ formatDate(row.created_at) }}
    </template>

    <!-- Windows Qty -->
    <template #windows_qty="{ row }">
      {{ row.windows_quantity }}
    </template>

    <!-- Glass Status -->
    <template #glass_status="{ row }">
      {{ row.glass_status || '-' }}
    </template>

    <!-- Delivery Status -->
    <template #delivery_status="{ row }">
      <span class="badge" :class="statusBadgeClass(row.delivery_status)">{{ statusLabel(row.delivery_status) }}</span>
    </template>

    <!-- Approval Remark -->
    <template #approval_remark="{ row }">
      {{ row.approval_remark || '-' }}
    </template>

    <!-- Actions -->
  <template #actions="{ row }">
  <div class="d-flex align-items-center gap-1">

    <!-- Edit -->
    <button 
      v-if="row.delivery_status !== 'rejected' && row.delivery_status !== 'dispatched'"
      class="btn btn-sm btn-outline-secondary" 
      title="Edit"
      @click="openEditDispatch(row.id)">
      <i class="ti ti-edit"></i>
    </button>


    <!-- Assign Installation Person -->
    <button
      v-if="row.delivery_status === 'dispatched' && !row.installer && auth?.installation_person?.is_manager"
      class="btn btn-sm btn-primary"
      title="Assign Installation Person"
      @click="$refs.dispatchModal.openAssignInstaller(row)"
      data-bs-toggle="modal"
      data-bs-target="#assign_installer_modal">
      <i class="ti ti-user-plus"></i>
    </button>

      <!-- Approve -->
      <button 
        v-if="row.delivery_status === 'approval_pending' && auth?.type === 'ADMIN'"
        class="btn btn-sm btn-success" 
        title="Approve"
        @click="approveDispatch(row.id)">
        <i class="ti ti-circle-check"></i>
      </button>

      <!-- Reject -->
      <button 
        v-if="row.delivery_status === 'approval_pending' && auth?.type === 'ADMIN'"
        class="btn btn-sm btn-danger" 
        title="Reject"
        @click="rejectDispatch(row.id)">
        <i class="ti ti-ban"></i>
      </button>

    <!-- Update Status -->
    <button 
      v-if="row.delivery_status === 'ready_for_dispatch' || row.delivery_status === 'approved' || row.delivery_status === 'pending' || row.delivery_status === 'partial_dispatched'"
      class="btn btn-sm btn-info text-white" 
      title="Update Status"
      @click="openUpdateStatus(row)" 
      data-bs-toggle="modal" 
      data-bs-target="#customer_dispatch_status_modal">
      <i class="ti ti-refresh"></i>
    </button>

    <!-- Delete -->
    <button 
      class="btn btn-sm btn-outline-danger" 
      title="Delete"
      @click="openDeleteDispatch(row)">
      <i class="ti ti-trash"></i>
    </button>

      <!-- WhatsApp Logs  -->
    <button 
      class="btn btn-sm btn-outline-success" 
      title="WhatsApp Logs"
      @click="openWhatsappLogs(row)">
      <i class="ti ti-brand-whatsapp"></i>
    </button>


  </div>
</template>
  </app-table>
</div>
 </div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<customer-dispatch-modal ref="dispatchModal" @updated="fetchDispatches"></customer-dispatch-modal>


<!-- WhatsApp Logs Modal -->
<div class="modal fade" id="whatsapp_logs_modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

      <div class="modal-header" style="background:#f0fdf4;border-bottom:1px solid #bbf7d0;padding:14px 20px;">
        <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#0f172a;">
          <i class="ti ti-brand-whatsapp me-2" style="color:#16a34a;"></i>
          WhatsApp Logs — {{ whatsappLogModalTitle }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <div class="modal-body" style="padding:20px;">

        <!-- Loading -->
        <div v-if="whatsappLogsLoading" style="text-align:center;padding:30px;">
          <div class="spinner-border text-success" role="status"></div>
        </div>

        <!-- No Logs -->
        <div v-else-if="!whatsappLogs.length" style="text-align:center;padding:30px;color:#94a3b8;">
          <i class="ti ti-message-off" style="font-size:32px;display:block;margin-bottom:8px;opacity:.4;"></i>
          No WhatsApp logs found.
        </div>

        <!-- Logs List -->
        <div v-else>
          <div v-for="log in whatsappLogs" :key="log.id"
            style="border:1.5px solid #e2e8f0;border-radius:10px;padding:12px 16px;margin-bottom:10px;">

            <div style="display:flex;justify-content:space-between;align-items:flex-start;">
              <div>
                <div style="font-size:12px;font-weight:700;color:#0f172a;text-transform:capitalize;">
                  {{ log.action?.replace('_', ' ') }}
                </div>
                <div style="font-size:11px;color:#64748b;margin-top:2px;">
                  <i class="ti ti-phone" style="font-size:11px;"></i> {{ log.recipient_phone }}
                </div>
              </div>
              <span class="badge" :class="whatsappStatusBadge(log.status)" style="font-size:10px;text-transform:capitalize;">
                {{ log.status }}
              </span>
            </div>

            <div v-if="log.params_sent?.length" style="margin-top:8px;font-size:11px;color:#475569;">
              <strong>Params:</strong> {{ log.params_sent.join(', ') }}
            </div>

            <div v-if="log.error_message" style="margin-top:6px;font-size:11px;color:#f43f5e;">
              <i class="ti ti-alert-circle"></i> {{ log.error_message }}
            </div>

            <div style="margin-top:8px;font-size:10.5px;color:#94a3b8;">
              <i class="ti ti-clock-hour-3"></i> {{ formatDateTime(log.created_at) }}
            </div>

          </div>
        </div>

      </div>

      <div class="modal-footer" style="padding:12px 20px;border-top:1px solid #e2e8f0;">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>

    </div>
  </div>
</div>

</template>

<style scoped>
.badge-yellow {
  background-color: #ffc107;
  color: #000;
}
.badge-orange {
  background-color: #fd7e14;
  color: #fff;
}
   .table-responsive {
        overflow-y: auto;
    }
</style>